import Grid from "@mui/material/Grid";
import { currencyBRL } from "../../util/DoubleUtil";
import { InfoItem } from "../PixTransacao/PixTransacaoView";

// Valores de cartaoFormaPagamento (conforme a legenda da versão anterior da tela).
export const FORMAS_PAGAMENTO_CARTAO = {
  0: "À vista",
  1: "Parcelado sem juros",
  2: "Parcelado com juros",
};

/** Detalhes completos de uma transação de cartão de crédito. */
const CartaoCreditoTransacaoView = ({ cartaoCreditoTransacao: t }) => (
  <Grid container spacing={2}>
    <InfoItem label="Código" value={t?.codigo} />
    <InfoItem label="Nº do pedido" value={t?.numeroPedido} />
    <InfoItem label="Identificador" value={t?.identificador} />
    <InfoItem label="Valor" value={currencyBRL(t?.valor)} />
    <InfoItem
      label="Forma de pagamento"
      value={FORMAS_PAGAMENTO_CARTAO[t?.cartaoFormaPagamento] ?? t?.cartaoFormaPagamento}
    />
    <InfoItem label="Parcelas" value={t?.quantidadeParcelas} />
    <InfoItem label="Nome impresso" value={t?.nomeImpresso} />
    <InfoItem label="Número do cartão" value={t?.numeroCartao} />
    <InfoItem label="Adquirente" value={t?.adquirente} />
    <InfoItem label="Cód. autorização" value={t?.codigoAutorizacao} />
    <InfoItem label="Nº autorização" value={t?.numeroAutorizacao} />
    <InfoItem label="NSU" value={t?.nsuOperacao} />
    <InfoItem label="Cliente" value={t?.clienteNome} />
    <InfoItem label="CPF/CNPJ" value={t?.clienteCpfCnpj} />
    <InfoItem label="E-mail" value={t?.clienteEmail} />
    <InfoItem label="IP do cliente" value={t?.clienteIP} />
    <InfoItem label="Descrição" value={t?.clienteDescricao} wide />
    <InfoItem label="Retorno" value={t?.retorno} wide />
    {t?.detalhesErro && <InfoItem label="Detalhes do erro" value={t.detalhesErro} wide />}
  </Grid>
);

export default CartaoCreditoTransacaoView;
